export const EShapeActionValueSubtyped = wcardinal.ui.EShapeActionValueSubtyped;